export default "tender-header-title = Tender Details\ntender-header-title-response = Tender Response"